<template>
  <div id="about-close" class="fs-12 ff-mono tt-u">Close</div>
</template>

<script setup>
const props = defineProps({});
const { $gsap: gsap } = useNuxtApp();

onMounted(() => {
  gsap.to('#about-close', {
    y: 0,
    duration: 1,
    scale: 1,
    startAt: { scale: 0 },
    delay: 1,
    ease: 'smooth',
    force3D: true,
  });
});
</script>

<style lang="scss" scoped>
#about-close {
  backdrop-filter: blur(5rem);
  background: rgba(100, 100, 100, 0.6);
  bottom: var(--offset-double);
  color: #fff;
  left: 0;
  display: flex;
  margin: 0 auto;
  padding: 1.5rem 2rem;
  position: fixed;
  right: 0;
  width: fit-content;
  z-index: layer(modal) + 1;
  transform: translateY(200%);
  will-change: transform;

  @include mq(desktop) {
    visibility: hidden;
  }
}
</style>
